import DetailPageWrapper from './DetailPageWrapper';

export default DetailPageWrapper;
